const TEMPLATE_LIBRARY_COMPONENT_ID_PREFIX = 'template_';

export const prefixTemplateLibraryComponentId = (libraryId: string, templateId: string): string =>
  `${templateId}_${TEMPLATE_LIBRARY_COMPONENT_ID_PREFIX}${libraryId}`;

export const unprefixTemplateLibraryComponentId = (prefixedLibraryId: string): string =>
  prefixedLibraryId.replace(new RegExp(`.*${TEMPLATE_LIBRARY_COMPONENT_ID_PREFIX}`), '');
